var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.9935 32.8559V32.8689H51.8857V32.8559H31.1445V20.7432H45.2571C41.6131 16.5292 36.271 13.8244 30.2629 13.8244C19.2784 13.8244 10.3771 22.7293 10.3771 33.7183C10.3771 44.7072 19.2784 53.6121 30.2629 53.6121C38.4849 53.6121 45.5314 48.6141 48.5551 41.4929C48.6335 41.5517 56.2351 49.2152 56.2547 49.2087C50.978 58.0678 41.3192 64 30.2629 64C13.551 64 0 50.4434 0 33.7248C0 16.9996 13.551 3.44957 30.2629 3.44957C38.7396 3.44957 46.3869 6.95141 51.8857 12.57V0H63.9935V20.7432H64V32.8559H63.9935Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.978f626bff4f8a25a6cb32ec0aba5efd.svg";
export { ForwardRef as ReactComponent };